import { render, staticRenderFns } from "./TheAlerts.vue?vue&type=template&id=54968714&"
import script from "./TheAlerts.vue?vue&type=script&lang=js&"
export * from "./TheAlerts.vue?vue&type=script&lang=js&"
import style0 from "./TheAlerts.vue?vue&type=style&index=0&id=54968714&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports